<template>
  <nav class="navbar navbar-expand-lg sticky-top">
    <div class="container-fluid">
      <RouterLink class="navbar-brand" to="/">So-Well Prepared Tax Prep</RouterLink>

      <button class="navbar-toggler" type="button" aria-label="Toggle navigation" @click="isOpen = !isOpen">
        <Menu />
      </button>
      <div class="navbar-collapse grow" :class="{ collapse: !isOpen, show: isOpen }" id="navbarScroll">
        <ul class="navbar-nav me-auto my-2 my-lg-0">
          <li class="nav-item">
            <RouterLink class="router-link" active-class="active-btn" :to="{ path: '/', hash: '#home' }"
              @click="isOpen = !isOpen">Profile
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink class="router-link" active-class="active-btn" to="/services" @click="isOpen = !isOpen">Services
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink class="router-link" active-class="active-btn" to="/help" @click="isOpen = !isOpen">Help
            </RouterLink>
          </li>
          <li class="nav-item">
            <a class="router-link" href="#contact" @click="isOpen = !isOpen">Contact</a>
          </li>
        </ul>
        <a class="router-link-appointment router-link-navbar" href="http://booking.sowellprepared.org">
          Make An Appointment
        </a>
      </div>
    </div>
  </nav>
  <main>
    <RouterView />
  </main>
  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="dialog" v-for="(dialog, index) in dialogs" :key="index">
            <h4> {{ dialog.title }}</h4>
            <p> {{ dialog.content }}</p>
            <a :href="dialog.href" v-if="dialog.href">Click For More Info</a>
          </div>
          <div class="carousel-container" v-if="this.carousels.length > 0">
            <div class="carousel-track">
              <div class="carousel-item" v-for="(carouselItem, index) in carousels" :key="index">
                <h4> {{ carouselItem.title }}</h4>
                <p> {{ carouselItem.content }}</p>
                <a :href="carouselItem.href" v-if="carouselItem.href">Click For More Info</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { getAnnouncements } from "@/api/backend"
import { Modal } from 'bootstrap'
import { Menu } from 'lucide-vue-next';

export default {
  name: 'App',
  components: {
    Menu
  },
  setup() {
    const isOpen = ref(false);

    return {
      isOpen,
    };
  },
  data() {
    return {
      announcements: {},
      dialogs: [],
      carousels: []
    }
  },
  methods: {
    showModal() {
      const modalElement = document.getElementById('staticBackdrop')
      const modalInstance = new Modal(modalElement)
      modalInstance.show()
    }
  },
  async beforeMount() {
    let fetchedAnnouncements = await getAnnouncements()
    this.announcements = fetchedAnnouncements
    if (this.announcements) {
      this.carousels = this.announcements["CAROUSEL"]
      this.dialogs = this.announcements["DIALOG"]
      if (this.carousels.length > 0 || this.dialogs.length > 0) {
        this.showModal()
      }
    }
  }
}
</script>

<style>
.navbar-toggler,
.navbar-toggler:focus {
  color: white !important;
  border: 1.2px solid white !important;
  box-shadow: none
}

.navbar {
  background: #263640;
  z-index: 1200;
}

#app {
  background: linear-gradient(135deg, #263640, #BDBCB5);
  background-size: cover;
  min-height: 100vh;
  overflow-x: hidden;
}

.navbar-collapse {
  transform: scale(0);
  /* start small */
  animation: grow 0.6s ease forwards;
}

.navbar-collapse.show {
  max-height: 500px;
  /* choose a value bigger than content height */
  opacity: 1;
  z-index: 1200;
}


@keyframes grow {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

@keyframes show {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(0);
  }
}

.router-link {
  color: white;
  text-decoration: none;
  margin-right: 0.75rem;
  padding: 0.5rem;
  font-size: 1.15rem
}

.router-link:hover {
  color: #2563eb
}

.router-link-appointment {
  background: #2563eb;
  color: white;
  text-decoration: none;
  padding: 0.5rem;
  border-radius: 7.5px
}

.navbar-brand,
.navbar-brand:hover,
.navbar-brand:focus {
  color: #f0f0f0;
  font-size: 2.5rem;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.active-btn {
  background-color: white;
  color: #2563eb;
  border-color: white;
  border-radius: 7.5px;
}

.carousel-container {
  overflow: hidden;
  position: relative;
}

.carousel-track {
  display: flex;
  animation: scroll 20s linear infinite;
  width: max-content;
}

.dialog {
  width: 100%;
  margin-bottom: 15px;
  background: #757575;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  border-radius: 10px;
  max-height: 500px;
}

.carousel-item {
  width: 100%;
  margin-right: 20px;
  margin-left: 20px;
  background: #0d0d0d;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  border-radius: 10px;
  max-height: 500px;
}

.carousel-item p,
.dialog p {
  font-size: 1.45rem;
  text-align: center;
}

.carousel-item h4,
.dialog h4 {
  font-size: 1.85rem;
  text-align: center;
}

.carousel-item a {
  font-size: 1.4rem;
  color: black;
  text-decoration: none;
  background-color: white;
  border-radius: 10px;
  padding: 0.25rem 0.5rem
}

.dialog a {
  font-size: 1.4rem;
  color: white;
  text-decoration: none;
  background-color: black;
  border-radius: 10px;
  padding: 0.25rem 0.5rem
}

.modal-footer {
  border-top: none;
  padding-top: 0.1rem
}

.modal-content {
  border-radius: 10px
}

.modal,
#staticBackdrop {
  z-index: 2000
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

@media(max-width: 1200px) and (min-width: 992px) {

  .navbar-brand,
  .navbar-brand:hover,
  .navbar-brand:focus {
    font-size: 2.25rem;
  }
}

@media(max-width: 992px) and (min-width: 768px) {

  .navbar-brand,
  .navbar-brand:hover,
  .navbar-brand:focus {
    font-size: 2.2rem;
  }

  .navbar li {
    margin-bottom: 0.1rem;
  }

  .active-btn {
    margin-bottom: 0.2rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 300px
  }

  .navbar-collapse.collapse {
    display: block !important;
    /* was: none */
  }

  /* Animate open/close with max-height + opacity */
  .navbar-collapse {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.75s ease, opacity 0.6s ease;
  }
}

@media(max-width: 768px) and (min-width: 576px) {

  .navbar-brand,
  .navbar-brand:hover,
  .navbar-brand:focus {
    font-size: 2rem;
  }

  .navbar li {
    margin-bottom: 0.1rem;
  }

  .active-btn {
    margin-bottom: 0.2rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 300px;
    font-size: 1.1rem
  }

  .navbar-collapse.collapse {
    display: block !important;
    /* was: none */
  }

  /* Animate open/close with max-height + opacity */
  .navbar-collapse {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 1s ease, opacity 0.6s ease;
  }
}

@media(max-width: 576px) and (min-width: 420px) {

  .navbar-brand,
  .navbar-brand:hover,
  .navbar-brand:focus {
    font-size: 1.75rem;
  }

  .navbar li {
    margin-bottom: 0.05rem;
  }

  .active-btn {
    margin-bottom: 0.1rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 250px;
    font-size: 1.05rem;
    padding: 0.35rem;
  }

  .dialog {
    margin-bottom: 10px;
    padding: 1.25rem 1rem;
    border-radius: 7.5px;
  }

  .carousel-item {
    margin-right: 15px;
    margin-left: 15px;
    padding: 1.25rem 1rem;
    border-radius: 7.5px;
  }

  .carousel-item p,
  .dialog p {
    font-size: 1.25rem;
    text-align: center;
  }

  .carousel-item h4,
  .dialog h4 {
    font-size: 1.75rem;
    text-align: center;
  }

  .carousel-item a {
    font-size: 1.3rem;
    border-radius: 7.5px;
    padding: 0.2rem 0.4rem
  }

  .dialog a {
    font-size: 1.3rem;
    border-radius: 7.5px;
    padding: 0.2rem 0.4rem
  }

  .navbar-collapse.collapse {
    display: block !important;
    /* was: none */
  }

  /* Animate open/close with max-height + opacity */
  .navbar-collapse {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 1s ease, opacity 0.6s ease;
  }
}

@media(max-width: 420px) and (min-width: 360px) {

  .navbar-brand,
  .navbar-brand:hover,
  .navbar-brand:focus {
    font-size: 1.35rem;
  }

  .navbar li {
    margin-bottom: 0.05rem;
  }

  .active-btn {
    margin-bottom: 0.1rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 225px;
    font-size: 0.95rem;
    padding: 0.35rem;
  }

  .dialog {
    margin-bottom: 10px;
    padding: 1.25rem 1rem;
    border-radius: 7.5px;
  }

  .carousel-item {
    margin-right: 15px;
    margin-left: 15px;
    padding: 1.25rem 1rem;
    border-radius: 7.5px;
  }

  .carousel-item p,
  .dialog p {
    font-size: 1.25rem;
    text-align: center;
  }

  .carousel-item h4,
  .dialog h4 {
    font-size: 1.75rem;
    text-align: center;
  }

  .carousel-item a {
    font-size: 1.3rem;
    border-radius: 7.5px;
    padding: 0.2rem 0.4rem
  }

  .dialog a {
    font-size: 1.3rem;
    border-radius: 7.5px;
    padding: 0.2rem 0.4rem
  }

  .navbar-collapse.collapse {
    display: block !important;
    /* was: none */
  }

  /* Animate open/close with max-height + opacity */
  .navbar-collapse {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 1s ease, opacity 0.6s ease;
  }
}

@media(max-width: 360px) {

  .navbar-brand,
  .navbar-brand:hover,
  .navbar-brand:focus {
    font-size: 1.15rem;
  }

  .navbar li {
    margin-bottom: 0.05rem;
  }

  .active-btn {
    margin-bottom: 0.1rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 200px;
    font-size: 0.85rem;
    padding: 0.25rem;
  }

  .dialog {
    margin-bottom: 10px;
    padding: 1.25rem 1rem;
    border-radius: 7.5px;
  }

  .carousel-item {
    margin-right: 15px;
    margin-left: 15px;
    padding: 1.25rem 1rem;
    border-radius: 7.5px;
  }

  .carousel-item p,
  .dialog p {
    font-size: 1.25rem;
    text-align: center;
  }

  .carousel-item h4,
  .dialog h4 {
    font-size: 1.75rem;
    text-align: center;
  }

  .carousel-item a {
    font-size: 1.3rem;
    border-radius: 7.5px;
    padding: 0.2rem 0.4rem
  }

  .dialog a {
    font-size: 1.3rem;
    border-radius: 7.5px;
    padding: 0.2rem 0.4rem
  }

  .modal-footer {
    padding-top: 0.2rem 0.4rem;
  }

  .navbar-collapse.collapse {
    display: block !important;
    /* was: none */
  }

  /* Animate open/close with max-height + opacity */
  .navbar-collapse {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 1s ease, opacity 0.6s ease;
  }
}
</style>
